import './index.css';
import { TextProfileIcon } from '../TextProfileIcon';
import { MessageInput } from '../MessageInput';
import { imageIcon, micIcon } from '../../assets';
import SocketStore from '../../stores/SocketStore';
import ChatStore from '../../stores/ChatStore';
import { observer } from 'mobx-react';
import { useEffect, useRef, useContext } from 'react';
import strings from '../../localization';
import UploadStore from '../../stores/UploadStore';
import CallStore from '../../stores/CallStore';
import MainStore from '../../stores/MainStore';
import AuthStore from '../../stores/AuthStore';
import { formatDateTime } from '../../helpers/functions';
import { SelffixLoadingContext } from '../../contexts/SelffixLoadingContext';
import { ModalAlertContext } from '../../contexts/ModalAlertContext';

const TypingIndicator = (name) => {
  return (
    <div key={'typing-indicator'} className={`call-chat-message call-chat-message-user`}>
      <TextProfileIcon text={name} isOnline={true} />
      <span>{strings.typing}</span>
    </div>
  );
}


const TechCallChat = ({ isPreview = false }) => {

  const messagesListRef = useRef(null);
  const { showSelffixLoading, closeSelffixLoading } = useContext(SelffixLoadingContext);
  const { showModalAlert, closeModalAlert } = useContext(ModalAlertContext);
  const sendMessage = (message) => {
    SocketStore.sendTechMessage({
      type: 'text',
      content: message
    });
  }

  useEffect(() => {
    setTimeout(() => {
      if (messagesListRef.current) {
        messagesListRef.current.scrollTo({
          top: messagesListRef.current.scrollHeight,
          behavior: 'smooth'
        });
      }
    }, 100);
  }, [ChatStore.messages.length]);


  const handleAddImage = (e) => {
    showSelffixLoading();
    const file = e.target.files[0];
    UploadStore.uploadFileToChat(file, CallStore.slug).then((response) => {
      if (response.success) {
        SocketStore.sendTechMessage({
          type: 'file',
          content: JSON.stringify(response.data)
        });
      } else {
        showModalAlert({
          title: strings.error,
          message: response.message,
          onConfirm: () => {
            closeModalAlert();
          },
          onCancel: null,
          type: 'error',
          confirmText: strings.ok,
        });
      }
      closeSelffixLoading();
    });
  };

  const user = AuthStore.user;
  const name = user?.name;
  const surname = user?.surname;
  const fullName = `${name} ${surname}`;

  const messages = !isPreview ? ChatStore.messages : (CallStore.messages || []);


  return (
    <div className="tech-call-chat-container">
      <div className="tech-call-chat-messages" ref={messagesListRef} >
        {messages.length > 0 && messages.map((message) => {

          const date = formatDateTime(message.timestamp ? message.timestamp : message.createdAt);

          return (
            <div key={message.id} className={`call-chat-message ${message.from === 'customer' ? 'call-chat-message-user' : 'call-chat-message-tech'}`}>
              <div className={`call-chat-message-inner ${message.message.type === 'file' ? 'call-chat-message-inner-file' : ''}`}>
                <TextProfileIcon text={message.from !== 'customer' ? fullName : message.from} isOnline />
                {message.message.type === 'text' && <span className='call-chat-message-text'>{message.message.content}</span>}
                {message.message.type === 'file' && <div className='tech-call-chat-message-file-container'>
                  <img
                    onClick={() => MainStore.setImageModalData(message.message.content)}
                    src={message.message.content.presignedUrl} alt="image" className='tech-call-chat-message-file-image' />
                </div>}
              </div>
              {date && <span className='call-chat-message-date'>{date}</span>}
            </div>
          )
        }
        )}
        {ChatStore.isTyping && TypingIndicator("customer")}
      </div>
      {!isPreview && <div className="tech-call-chat-bottom-container">
        <div className="tech-call-chat-message-input-container">
          <MessageInput onSend={sendMessage} role="technician" />
        </div>
        <div className="tech-call-chat-bottom-container-buttons">
          <button className="button-round" onClick={() => document.getElementById('imageInput').click()}>
            <input id="imageInput" type="file" accept="image/*" onChange={handleAddImage} style={{ display: 'none' }} />
            <img src={imageIcon} alt="image" />
          </button>
        </div>
      </div>}
    </div>
  );
}

export default observer(TechCallChat);